var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconCalendrier(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 22,
    viewBox: "0 0 20 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 1V5M6 1V5",
    stroke: "#AEB6FB",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11 3H9C5.22876 3 3.34315 3 2.17157 4.17157C1 5.34315 1 7.22876 1 11V13C1 16.7712 1 18.6569 2.17157 19.8284C3.34315 21 5.22876 21 9 21H11C14.7712 21 16.6569 21 17.8284 19.8284C19 18.6569 19 16.7712 19 13V11C19 7.22876 19 5.34315 17.8284 4.17157C16.6569 3 14.7712 3 11 3Z",
    stroke: "#AEB6FB",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1 9H19",
    stroke: "#AEB6FB",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8 17.5002L7.99999 12.8474C7.99999 12.6557 7.86325 12.5002 7.69458 12.5002H7M12 17.4983L13.4855 12.8923C13.4951 12.8626 13.5 12.8315 13.5 12.8002C13.5 12.6346 13.3657 12.5002 13.2 12.5002L11 12.5",
    stroke: "#AEB6FB",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCalendrier);
export default __webpack_public_path__ + "static/media/iconCalendrier.fc2426aefea69f44b4efd2aa14a2b667.svg";
export { ForwardRef as ReactComponent };